import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Modal } from '../components/ui/Modal';
import { Pagination } from '../components/ui/Pagination';
import { useSearch } from '../hooks/useSearch';
import { useFilters } from '../hooks/useFilters';
import { usePagination } from '../hooks/usePagination';
import { ColumnCustomizer } from '../components/ColumnCustomizer';
import { Plus, Filter, Download, Eye, Edit, Search, Building2, Trash2, X, Save, CheckCircle2, AlertCircle, MapPin } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Tooltip } from '../components/ui/Tooltip';
const initialStudiesData = Array.from({
  length: 50
}, (_, i) => ({
  id: i + 1,
  name: i % 2 === 0 ? `Studio Commerciale ${i}` : `Studio Lavoro ${i}`,
  type: i % 2 === 0 ? 'Commercialista' : 'Consulente del Lavoro',
  city: ['Arezzo', 'Firenze', 'Siena', 'Perugia', 'Prato', 'Sansepolcro'][i % 6],
  email: `info@studio${i}.it`,
  phone: `0575 ${200000 + i}`,
  via: 'Via Roma',
  civico: `${10 + i}`,
  comune: ['Arezzo', 'Firenze', 'Siena', 'Perugia', 'Prato', 'Sansepolcro'][i % 6],
  cap: '52100',
  provincia: ['AR', 'FI', 'SI', 'PG', 'PO', 'AR'][i % 6]
}));
const columnsConfig = [{
  key: 'name',
  label: 'Ragione sociale'
}, {
  key: 'type',
  label: 'Tipologia'
}, {
  key: 'city',
  label: 'Città'
}, {
  key: 'email',
  label: 'Email'
}, {
  key: 'phone',
  label: 'Telefono'
}, {
  key: 'actions',
  label: 'Azioni'
}];
export function StudiesPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showFilters, setShowFilters] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(columnsConfig.map(c => c.key));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const {
    addNotification
  } = useNotifications();
  const {
    filters,
    setFilter,
    clearFilters,
    filteredData: filterResult
  } = useFilters(initialStudiesData);
  const {
    searchTerm,
    setSearchTerm,
    filteredData: searchResult
  } = useSearch(filterResult, ['name', 'email']);
  const {
    currentPage,
    totalPages,
    paginatedData,
    goToPage,
    pageSize,
    setPageSize,
    totalItems,
    setCurrentPage
  } = usePagination(searchResult);
  useEffect(() => {
    setCurrentPage(1);
  }, [filters, searchTerm]);
  const handleView = (item: any) => {
    setSelectedItem(item);
    setIsViewModalOpen(true);
  };
  const handleEdit = (item: any) => {
    setSelectedItem(item);
    setFormData(item);
    setIsModalOpen(true);
  };
  const handleCreate = () => {
    setSelectedItem(null);
    setFormData({});
    setIsModalOpen(true);
  };
  const handleDelete = (item: any) => {
    setSelectedItem(item);
    setIsDeleteConfirmOpen(true);
  };
  const confirmDelete = () => {
    setDeleteSuccess(true);
    setTimeout(() => {
      setDeleteSuccess(false);
      setIsDeleteConfirmOpen(false);
      addNotification('success', 'Studio eliminato', 'Lo studio è stato eliminato con successo.');
    }, 1500);
  };
  const handleSave = () => {
    setSaveSuccess(true);
    setTimeout(() => {
      setSaveSuccess(false);
      setIsModalOpen(false);
      addNotification('success', 'Studio salvato', 'Lo studio è stato salvato con successo.');
    }, 2000);
  };
  const hasActiveFilters = Object.keys(filters).some(k => filters[k]);
  // Get unique cities for filter
  const uniqueCities = Array.from(new Set(initialStudiesData.map(item => item.city))).sort();
  return <Layout data-id="element-5665" data-mp="29u6e3olidzij">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-5666" data-mp="29toh2pr0vh9k">
        <div data-id="element-5667" data-mp="1m5dnm7nnojvb">
          <h1 className="text-3xl font-bold text-seform-navy" data-id="element-5668" data-mp="1m55aqfrj9ek4">
            Anagrafica studi
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-5669" data-mp="1i4bnlolx03sa">
            Gestione partner esterni (Commercialisti, Consulenti del Lavoro).
          </p>
        </div>
        <div className="flex gap-3" data-id="element-5670" data-mp="1r3owog64mqch">
          <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-5672" data-mp="13cszt4mtd4yd" />} data-id="element-5671" data-mp="1r2nabfjnuhfg">
            Esporta
          </Button>
          <Button onClick={handleCreate} startContent={<Plus className="h-4 w-4" data-id="element-5674" data-mp="3a2d2nc2xjew4" />} data-id="element-5673" data-mp="ydq44asq4b32">
            Nuovo studio
          </Button>
        </div>
      </div>

      <Card className="mb-6" noPadding data-id="element-5675" data-mp="3et378n3j7dpr">
        <div className="p-4 flex flex-col gap-4" data-id="element-5676" data-mp="3eu4lf0fuggbp">
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-5677" data-mp="311ydu2qrbhnv">
            <div className="flex-1" data-id="element-5678" data-mp="30zc01ld9w5x7">
              <Input placeholder="Cerca studio..." startContent={<Search className="h-4 w-4" data-id="element-5680" data-mp="3tqdfzoosi5hs" />} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} fullWidth data-id="element-5679" data-mp="35zzuyi4mh6wp" />
            </div>
            <div className="flex gap-2" data-id="element-5681" data-mp="3js6bw6flnhx7">
              <Button variant={showFilters ? 'solid' : 'flat'} color="secondary" onClick={() => setShowFilters(!showFilters)} startContent={<Filter className="h-4 w-4" data-id="element-5683" data-mp="28bpxmgfs77bx" />} data-id="element-5682" data-mp="3jr4sneofjp4e">
                Filtri{' '}
                {hasActiveFilters && <Badge variant="primary" size="sm" className="ml-1" data-id="element-5684" data-mp="2d9rbmmycoggj">
                    {Object.keys(filters).filter(k => filters[k]).length}
                  </Badge>}
              </Button>
              <ColumnCustomizer columns={columnsConfig} visibleColumns={visibleColumns} onColumnChange={setVisibleColumns} pageKey="studies" data-id="element-5685" data-mp="1paibyixy6x0c" />
            </div>
          </div>

          {showFilters && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-5686" data-mp="1ah5c7a5jzgeh">
              <Select label="Tipologia" value={filters.type || ''} onChange={e => setFilter('type', e.target.value)} options={[{
            value: '',
            label: 'Tutte'
          }, {
            value: 'Commercialista',
            label: 'Commercialista'
          }, {
            value: 'Consulente del Lavoro',
            label: 'Consulente del Lavoro'
          }, {
            value: 'Altro',
            label: 'Altro'
          }]} data-id="element-5687" data-mp="11hs2qhhfirtr" />
              <Select label="Città" value={filters.city || ''} onChange={e => setFilter('city', e.target.value)} options={[{
            value: '',
            label: 'Tutte'
          }, ...uniqueCities.map(city => ({
            value: city,
            label: city
          }))]} data-id="element-5688" data-mp="3d5dpfc2sp541" />
              <div className="col-span-full flex justify-end" data-id="element-5689" data-mp="4qvacqefspax">
                <Button variant="flat" color="danger" size="sm" onClick={clearFilters} startContent={<X className="h-4 w-4" data-id="element-5691" data-mp="utigr7h08kae" />} data-id="element-5690" data-mp="8roynkvsk64c">
                  Resetta filtri
                </Button>
              </div>
            </div>}
        </div>
      </Card>

      <Card noPadding className="overflow-hidden" data-id="element-5692" data-mp="14klkyi58dfdw">
        <div className="overflow-x-auto" data-id="element-5693" data-mp="zrse9oq7bwz6">
          <table className="w-full text-left border-collapse" data-id="element-5694" data-mp="zqr3zmh0feii">
            <thead data-id="element-5695" data-mp="1dixi730lrbfb">
              <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-5696" data-mp="1difc7eo51iu7">
                {columnsConfig.filter(c => visibleColumns.includes(c.key)).map(col => <th key={col.key} className={`px-6 py-4 ${col.key === 'actions' ? 'text-left w-32' : ''}`} data-id="element-5697" data-mp="1iia4nmnkaghd">
                      {col.label}
                    </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-5698" data-mp="1zse1gnl1vktg">
              {paginatedData.map(item => <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group" data-id="element-5699" data-mp="24rqmr3w9wjtx">
                  {visibleColumns.includes('name') && <td className="px-6 py-4 font-medium text-slate-900" data-id="element-5700" data-mp="1v0vw7nbzuy2o">
                      {item.name}
                    </td>}
                  {visibleColumns.includes('type') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-5701" data-mp="1l3hrum3chzqq">
                      {item.type}
                    </td>}
                  {visibleColumns.includes('city') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-5702" data-mp="1c3mce52rbikw">
                      {item.city}
                    </td>}
                  {visibleColumns.includes('email') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-5703" data-mp="36f9k2s6qzdip">
                      {item.email}
                    </td>}
                  {visibleColumns.includes('phone') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-5704" data-mp="2qtolimigafit">
                      {item.phone}
                    </td>}
                  {visibleColumns.includes('actions') && <td className="px-6 py-4" data-id="element-5705" data-mp="2i01t96dgbued">
                      <div className="flex items-center gap-1" data-id="element-5706" data-mp="35ouspcta8kdq">
                        <Tooltip content="Visualizza studio" data-id="element-5707" data-mp="35na03sqj3bii">
                          <Button variant="light" size="sm" className="!px-1" onClick={() => handleView(item)} data-id="element-5708" data-mp="39pogm66q5z6m">
                            <Eye className="h-4 w-4 text-slate-500" data-id="element-5709" data-mp="1kc1hmg2mhfth" />
                          </Button>
                        </Tooltip>
                        <Tooltip content="Modifica studio" data-id="element-5710" data-mp="1pc5wy2rso4i4">
                          <Button variant="light" size="sm" className="!px-1" onClick={() => handleEdit(item)} data-id="element-5711" data-mp="1hrlj07i0qu0w">
                            <Edit className="h-4 w-4 text-seform-orange" data-id="element-5712" data-mp="1qr0750apqsi8" />
                          </Button>
                        </Tooltip>
                        <Tooltip content="Elimina studio" data-id="element-5713" data-mp="y3m8mxrd9ow0">
                          <Button variant="light" size="sm" className="!px-1" onClick={() => handleDelete(item)} data-id="element-5714" data-mp="y45rcgouchb3">
                            <Trash2 className="h-4 w-4 text-red-500" data-id="element-5715" data-mp="132z60cfv6ecu" />
                          </Button>
                        </Tooltip>
                      </div>
                    </td>}
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="border-t border-slate-100" data-id="element-5716" data-mp="2agkqttexj7cy">
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={goToPage} totalItems={totalItems} pageSize={pageSize} onPageSizeChange={setPageSize} data-id="element-5717" data-mp="2afrrvem7pm5d" />
        </div>
      </Card>

      {/* View Modal (Consultation) */}
      <Modal isOpen={isViewModalOpen} onClose={() => setIsViewModalOpen(false)} title="Dettaglio studio" size="lg" data-id="element-5718" data-mp="2p7a2ewwayohc">
        {selectedItem && <div className="space-y-6" data-id="element-5719" data-mp="1wgs5kdm69jcd">
            <div className="grid grid-cols-2 gap-4" data-id="element-5720" data-mp="21fuyx0ssi14i">
              <div data-id="element-5721" data-mp="21e1t1nq03kxk">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5722" data-mp="21hzckaghqehz">
                  Ragione sociale
                </span>
                <p className="font-medium" data-id="element-5723" data-mp="3cvjlvs61n05b">{selectedItem.name}</p>
              </div>
              <div data-id="element-5724" data-mp="3gw3j0vqma3rg">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5725" data-mp="3gvlmdy01lnj0">
                  Tipologia
                </span>
                <p className="font-medium" data-id="element-5726" data-mp="1588ej0ud0pmk">{selectedItem.type}</p>
              </div>
              <div data-id="element-5727" data-mp="118pxwh9kn0pj">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5728" data-mp="119j5fkgctu8q">
                  Città
                </span>
                <p className="font-medium" data-id="element-5729" data-mp="rhv7r1t7fgyt">{selectedItem.city}</p>
              </div>
              <div data-id="element-5730" data-mp="rfshqhs1xnu3">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5731" data-mp="mia5ahetsqhc">
                  Email
                </span>
                <p className="font-medium" data-id="element-5732" data-mp="hie6qxowdr96">{selectedItem.email}</p>
              </div>
              <div data-id="element-5733" data-mp="dh2cgev2whun">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5734" data-mp="din6m3dhdyrz">
                  Telefono
                </span>
                <p className="font-medium" data-id="element-5735" data-mp="8l3sd3gs9m01">{selectedItem.phone}</p>
              </div>
            </div>

            <div className="h-px bg-slate-100" data-id="element-5736" data-mp="27tiojwak2q7f"></div>

            <section data-id="element-5737" data-mp="22y3e7ebrbcfr">
              <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5738" data-mp="22xjtjpuq29y1">
                <MapPin className="h-4 w-4" data-id="element-5739" data-mp="zk1s3yxz3gkd" /> Indirizzo
              </h4>
              <div className="grid grid-cols-2 gap-4" data-id="element-5740" data-mp="14k68loyvsbal">
                <div data-id="element-5741" data-mp="qlptb9mydcgu">
                  <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5742" data-mp="qkem0zuatmkz">
                    Via
                  </span>
                  <p className="font-medium" data-id="element-5743" data-mp="vmdqye5osrk1">{selectedItem.via}</p>
                </div>
                <div data-id="element-5744" data-mp="gu265kxfihl6">
                  <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5745" data-mp="gtk2i38ft138">
                    Civico
                  </span>
                  <p className="font-medium" data-id="element-5746" data-mp="7vhu32mdj65x">{selectedItem.civico}</p>
                </div>
                <div data-id="element-5747" data-mp="bvs5wvwukqsp">
                  <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5748" data-mp="bx3bn19us8mg">
                    Comune
                  </span>
                  <p className="font-medium" data-id="element-5749" data-mp="3u3zracdjzp05">{selectedItem.comune}</p>
                </div>
                <div data-id="element-5750" data-mp="2xomq69c4642">
                  <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5751" data-mp="3ff7xheb48wj8">
                    CAP
                  </span>
                  <p className="font-medium" data-id="element-5752" data-mp="3agwiyq9vlxuo">{selectedItem.cap}</p>
                </div>
                <div data-id="element-5753" data-mp="3pdx6sioy58nv">
                  <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-5754" data-mp="3pe5i465f85wy">
                    Provincia
                  </span>
                  <p className="font-medium" data-id="element-5755" data-mp="3kgnix7h7h525">{selectedItem.provincia}</p>
                </div>
              </div>
            </section>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-5756" data-mp="3tfil88h4pv06">
              <Button variant="flat" color="default" onClick={() => setIsViewModalOpen(false)} data-id="element-5757" data-mp="by7swngfb408">
                Chiudi
              </Button>
              <Button onClick={() => {
            setIsViewModalOpen(false);
            handleEdit(selectedItem);
          }} startContent={<Edit className="h-4 w-4" data-id="element-5759" data-mp="gvr7xpky3kt8" />} data-id="element-5758" data-mp="kynvlupce741">
                Modifica
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Create/Edit Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={selectedItem ? 'Modifica studio' : 'Nuovo studio'} size="2xl" data-id="element-5760" data-mp="sxircfz6kor3">
        <AnimatePresence mode="wait" data-id="element-5761" data-mp="12qzmbnb209wc">
          {saveSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center justify-center py-16" data-id="element-5762" data-mp="16q8ggta0a9sf">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 150,
            damping: 15,
            delay: 0.1
          }} className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-5763" data-mp="3ii47kjr0ga9k">
                <CheckCircle2 className="w-12 h-12 text-green-500" data-id="element-5764" data-mp="1qtwfiqgwifr9" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-5765" data-mp="2nk5f8btu1rh4">
                Studio salvato con successo
              </p>
            </motion.div> : <motion.div key="form" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-5766" data-mp="2jg7ig7rzcsr8">
              <div className="space-y-8" data-id="element-5767" data-mp="29m8fj6k314y8">
                <section data-id="element-5768" data-mp="134tqgxjxtkmq">
                  <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5769" data-mp="135d6g8q11yy4">
                    <Building2 className="h-4 w-4" data-id="element-5770" data-mp="y71y62fdrwi0" /> Dettagli studio
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5771" data-mp="2y91ki94qu3yf">
                    <Input label="Ragione sociale" value={formData.name || ''} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} required data-id="element-5772" data-mp="337ml49nwqpne" />
                    <Select label="Tipologia" value={formData.type || ''} onChange={e => setFormData({
                  ...formData,
                  type: e.target.value
                })} options={[{
                  value: 'Commercialista',
                  label: 'Commercialista'
                }, {
                  value: 'Consulente del Lavoro',
                  label: 'Consulente del Lavoro'
                }, {
                  value: 'Altro',
                  label: 'Altro'
                }]} required data-id="element-5773" data-mp="3lv81vm024w1b" />
                    <Input label="Email" type="email" value={formData.email || ''} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} data-id="element-5774" data-mp="1a9poatrjd2lm" />
                    <Input label="Telefono" type="tel" value={formData.phone || ''} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} data-id="element-5775" data-mp="2unzn6xfraie8" />
                  </div>
                </section>

                <div className="h-px bg-slate-100" data-id="element-5776" data-mp="2pcne0rqdntgs"></div>

                <section data-id="element-5777" data-mp="2kelt019e5k2o">
                  <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5778" data-mp="2kec5ckbtjp05">
                    <MapPin className="h-4 w-4" data-id="element-5779" data-mp="2udt7wsvrxmrw" /> Indirizzo
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-6 gap-6" data-id="element-5780" data-mp="2ubqleittybrx">
                    <div className="md:col-span-4" data-id="element-5781" data-mp="383wrfc39r2dn">
                      <Input label="Via" value={formData.via || ''} onChange={e => setFormData({
                    ...formData,
                    via: e.target.value
                  })} data-id="element-5782" data-mp="336ep44jrblem" />
                    </div>
                    <div className="md:col-span-2" data-id="element-5783" data-mp="4mbl6946oqrq">
                      <Input label="Civico" value={formData.civico || ''} onChange={e => setFormData({
                    ...formData,
                    civico: e.target.value
                  })} data-id="element-5784" data-mp="4l0h086tth03" />
                    </div>
                    <div className="md:col-span-3" data-id="element-5785" data-mp="3huepnyg2ks8f">
                      <Input label="Comune" value={formData.comune || ''} onChange={e => setFormData({
                    ...formData,
                    comune: e.target.value
                  })} data-id="element-5786" data-mp="341p4fw8d7rcd" />
                    </div>
                    <div className="md:col-span-2" data-id="element-5787" data-mp="2fxh4qlhotzmn">
                      <Input label="CAP" value={formData.cap || ''} onChange={e => setFormData({
                    ...formData,
                    cap: e.target.value
                  })} data-id="element-5788" data-mp="2fzae48joqxyc" />
                    </div>
                    <div className="md:col-span-1" data-id="element-5789" data-mp="2yw349vxk3iog">
                      <Input label="Prov." value={formData.provincia || ''} onChange={e => setFormData({
                    ...formData,
                    provincia: e.target.value
                  })} maxLength={2} data-id="element-5790" data-mp="2txrvzpmwtg8c" />
                    </div>
                  </div>
                </section>

                <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-5791" data-mp="3k7irh4lqtc9s">
                  <Button variant="flat" color="default" onClick={() => setIsModalOpen(false)} data-id="element-5792" data-mp="3k5ob83lf28c1">
                    Annulla
                  </Button>
                  <Button onClick={handleSave} startContent={<Save className="h-4 w-4" data-id="element-5794" data-mp="7qdw9fa2szzb" />} data-id="element-5793" data-mp="2rj0lcr0fgxs">
                    Salva studio
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isDeleteConfirmOpen} onClose={() => setIsDeleteConfirmOpen(false)} title="Conferma eliminazione" size="sm" data-id="element-5795" data-mp="gozcv4vzm4xg">
        <AnimatePresence mode="wait" data-id="element-5796" data-mp="2ijq823tcgvkl">
          {deleteSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center justify-center py-12" data-id="element-5797" data-mp="2nggncoxbrn4y">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 150,
            damping: 15,
            delay: 0.1
          }} className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-5798" data-mp="mt3uwbvdq91i">
                <CheckCircle2 className="w-10 h-10 text-green-500" data-id="element-5799" data-mp="3bjd81vse74hx" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-5800" data-mp="37ijhsvrh9dlv">
                Eliminato con successo
              </p>
            </motion.div> : <motion.div key="confirm" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-5801" data-mp="2xc9x8smy3mcp">
              <div className="space-y-6" data-id="element-5802" data-mp="2ne2kklzovqgi">
                <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-5803" data-mp="2segs82xdoye0">
                  <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-5804" data-mp="3g4b5gllm0oys" />
                  <p className="text-sm text-red-700" data-id="element-5805" data-mp="3l3xf6l28bn2u">
                    Attenzione: questa azione è irreversibile. Lo studio verrà
                    eliminato definitivamente.
                  </p>
                </div>
                <div className="flex justify-end gap-3 pt-4" data-id="element-5806" data-mp="3b4yi7zqttfvo">
                  <Button variant="flat" color="default" onClick={() => setIsDeleteConfirmOpen(false)} data-id="element-5807" data-mp="3b7kqk1ljjzey">
                    Annulla
                  </Button>
                  <Button color="danger" onClick={confirmDelete} data-id="element-5808" data-mp="6857b24leu4j">
                    Elimina
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>
    </Layout>;
}